export default "__VITE_ASSET__BuzzRnC___"